<template>
    <div class="container">
        <div class="content-wrapper">
            <aside class="left-col max600n">
                <ul>
                    <li v-bind:class="{'active': !this.$route.query.filter}">
                        <a href="/mainContent">
                            <img src="images/icons/patients-icon.svg" alt="" />
                            <span>{{ $t('The patients') }}</span>
                        </a>

                    </li>
                    <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Macular pathology'}">
                        <a href="/mainContent?filter=Macular pathology">
                            <span>{{ $t('Macular pathology') }}</span>
                        </a>
                    </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Central and branch retinal vein occlusion'}">
                        <a href="/mainContent?filter=Central and branch retinal vein occlusion">
                            <span>{{ $t('Central and branch retinal vein occlusion') }}</span>
                        </a>
                    </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Central and branch retinal arterial occlusion'}">
                        <a href="/mainContent?filter=Central and branch retinal arterial occlusion">
                            <span>{{ $t('Central and branch retinal arterial occlusion') }}</span>
                        </a>
                    </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Diabetic retinopathy'}">
                        <a href="/mainContent?filter=Diabetic retinopathy">
                            <span>{{ $t('Diabetic retinopathy') }}</span>
                        </a>
                    </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Optic nerve head pathology'}">
                        <a href="/mainContent?filter=Optic nerve head pathology">
                            <span>{{ $t('Optic nerve head pathology') }}</span>
                        </a>
                    </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Clear'}">
                        <a href="/mainContent?filter=Clear">
                            <span>{{ $t('Clear') }}</span>
                        </a>
                    </li>
                </ul>
            </aside>
            <main>
                <section class="search">
                    <div class="search-wrapper">
                        <input name="search" value="" ref="search" type="search" :placeholder="$t('Search')">
                    </div>



                    <div class="avatar">
                      <select class="lang-dropdown" v-model="lang">
                        <option
                            v-for="(lang, i) in languageArray"
                            :key="`lang${i}`"
                            :value="lang"
                        >
                          {{ lang }}
                        </option>
                      </select>
                      <a href="/user"><img style="width: 40px; float: left;margin-right: 10px;" src="/person.jpg" alt="person"></a>
                      <a class="nav-link" href ref="logOut">
                        {{ $t('Logout') }}
                      </a>
                    </div>
                </section>
              <aside class="left-col min600n max600b">
                <ul>
                  <li v-bind:class="{'active': !this.$route.query.filter}">
                    <a href="/mainContent">
                      <img src="images/icons/patients-icon.svg" alt="" />
                      <span>{{ $t('The patients') }}</span>
                    </a>

                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Macular pathology'}">
                    <a href="/mainContent?filter=Macular pathology">
                      <span>{{ $t('Macular pathology') }}</span>
                    </a>
                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Central and branch retinal vein occlusion'}">
                    <a href="/mainContent?filter=Central and branch retinal vein occlusion">
                      <span>{{ $t('Central and branch retinal vein occlusion') }}</span>
                    </a>
                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Central and branch retinal arterial occlusion'}">
                    <a href="/mainContent?filter=Central and branch retinal arterial occlusion">
                      <span>{{ $t('Central and branch retinal arterial occlusion') }}</span>
                    </a>
                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Diabetic retinopathy'}">
                    <a href="/mainContent?filter=Diabetic retinopathy">
                      <span>{{ $t('Diabetic retinopathy') }}</span>
                    </a>
                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Optic nerve head pathology'}">
                    <a href="/mainContent?filter=Optic nerve head pathology">
                      <span>{{ $t('Optic nerve head pathology') }}</span>
                    </a>
                  </li>
                  <li class="filter" v-bind:class="{'active': this.$route.query.filter=='Clear'}">
                    <a href="/mainContent?filter=Clear">
                      <span>{{ $t('Clear') }}</span>
                    </a>
                  </li>
                </ul>
              </aside>
                <section class="content">
                     <router-view />

                </section>
            </main>
        </div>



    </div>
</template>
<script>
import i18n,{ languages } from '@/plugins/i18n'
export default {
  data() {
    return {
      languageArray: languages
    }
  },
  computed: {
    lang: {
      get: function() {
        i18n.locale = this.$store.state.locale
        return this.$store.state.locale
      },
      set: function(newVal) {
        this.$store.dispatch('changeLocale', newVal)
      }
    }
  }
}
</script>
